// Angular
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
// Layout
import { OffcanvasOptions } from '../../../../core/_base/layout';
import { AppService } from '../../../../services/app.service';
import { StateService } from '../../../../services/state.service';

import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material';

@Component({
	selector: 'kt-quick-panel',
	templateUrl: './quick-panel.component.html',
	styleUrls: ['./quick-panel.component.scss'],
	providers: [AppService]
})
export class QuickPanelComponent implements OnInit{

	notifications: any;
	// Public properties
	
	notifOnCourseCount:number=0;
	notifHistoriqueCount:number=0;
	
	offcanvasOptions: OffcanvasOptions = {
		overlay: true,
		baseClass: 'kt-quick-panel',
		closeBy: 'kt_quick_panel_close_btn',
		toggleBy: 'kt_quick_panel_toggler_btn'
	};

	constructor (
		private appService:AppService,
		private stateService:StateService,
		private changeDetectorRef:ChangeDetectorRef,
		private router: Router,
		private snackBar: MatSnackBar
	) { 

	}
	ngOnInit() {
		this.notifications = this.stateService.notifications.getValue();
		this.setNotificationCount();
		this.stateService._notifications.subscribe((notifs: any) => {
			this.notifications = notifs;
			this.changeDetectorRef.detectChanges();
		});
	}
	
	
	setNotificationCount() {
		if (this.notifications.notifications) {
			this.notifHistoriqueCount=0;
			this.notifOnCourseCount=0;
			
			for(let i=0;i<this.notifications.notifications.length;i++) {
				let notif:any=this.notifications.notifications[i]
			    
				 if (notif.instruction!=undefined  
						&& notif.instruction.etape!=undefined) {
						if (notif.instruction.etape.historique)
							this.notifHistoriqueCount++;
						else
							this.notifOnCourseCount++;
							
					}
				
			}
			this.changeDetectorRef.detectChanges()
		}
	}

    setNotification(event: MouseEvent, notif: any, actions: any) {
		event.stopPropagation();
		event.preventDefault();
		this.appService.setNotification(notif.id, actions).subscribe((res) => {
			this.appService.getAllNotifications().subscribe((notifs) => {
				this.stateService.updateNotifications(notifs.result);
			});
		});
	}
	
	routerLink(notif: any) {
		//this.router.navigate(['/home/assistmat/' + notif.instruction.demande.dossier.ID]); 
		console.log("Notification router link object",notif);	
		
		this.appService.notifSeen(notif.id).subscribe((res) => {
			var typeTiers= notif.instruction.demande.dossier.tiers.type;
			var rt:string='assistmat'
			if(typeTiers === 'ASSMAT')
					rt='assistmat';
			else if(typeTiers   === 'EAJE')	
				rt='eaje';	
			else if(typeTiers  === 'MAM')	
						rt='mam';	
			else if(typeTiers  === 'GESTIONNAIRE')
						rt='gestionnaire';	
			else if(typeTiers  === 'STRUCTURE_GESTION')
						rt='structgestion';	
			else if(typeTiers  === 'RAM')
						rt='ram';	
			else if(typeTiers  === 'ASSFAM')
						rt='assistfam';	
			else if(typeTiers  === 'ENFANT')
						rt='enfant';	
		    else if(typeTiers  === 'GAT')
					rt='gat';	
			else if(typeTiers  === 'CCPD')
						rt='ccpd';	
			else if(typeTiers  === 'CA')
					rt='ca';
			else if(typeTiers  === 'ASSMAT_MAM')
					rt='amatam';		
			
			console.log("Notification router link",typeTiers,rt);																																																			
																																									
			this.router.navigate(['/home/'+rt+'/'+	 notif.instruction.demande.dossier.ID]);
			
			
			
	});
	
	this.appService.getAllNotifications().subscribe((notifs) => {
										this.stateService.updateNotifications(notifs.result)
										this.setNotificationCount();
				
			});
	}
}
